import { render, staticRenderFns } from "./createShortcode.vue?vue&type=template&id=4bfa4eda&scoped=true&"
import script from "./createShortcode.vue?vue&type=script&lang=js&"
export * from "./createShortcode.vue?vue&type=script&lang=js&"
import style0 from "./createShortcode.vue?vue&type=style&index=0&id=4bfa4eda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa4eda",
  null
  
)

export default component.exports